import { Directive, inject } from '@angular/core';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';

@Directive({})
export class SavingPlansPageBase {
  public readonly savingPlansFacade = inject(SavingsPlanFacade);

  public loadSavingsPlans(force = false): void {
    this.savingPlansFacade.loadSavingsPlansOverview(force);
  }
}
